require('jquery');
const lightbox = require('lightbox2');
import { TweenLite, TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import InfiniteScroll from 'infinite-scroll';
import PressRoom from '../class/PressRoom';

class Press {
	constructor() {
		this.sections = document.querySelectorAll('.press');
		this.sections.forEach((section) => new Section(section));

		lightbox.option({
			alwaysShowNavOnTouchDevices: true,
			resizeDuration: 400,
			wrapAround: true,
			disableScrolling: false,
			positionFromTop: 120,
		});
		this.animate();
	}

	animate() {
		this.sections.forEach((section) => {
			const timeline = new TimelineLite();

			const blocks = section.querySelectorAll('.tease-press');
			if (blocks) {
				const blocksAnimation = TweenMax.fromTo(blocks, 0.3, { y: 150, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
				timeline.add(blocksAnimation);
			}

			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: 0.85,
				offset: 0,
				reverse: false,
			})
				.setTween(timeline)
				.addTo(ScrollMagicController.controller);
		});
	}
}

class Section {
	constructor(section) {
		this.pressRoom = new PressRoom(section, { prefetch: true });
		this.section = section;
		this.postsPerPage = section.dataset.postsPerPage;
		this.postsContainer = section.querySelector('.press__posts');
		this.loadMoreButton = section.querySelector('.view-more-button');
		this.initInfiniteScroll();
	}

	initInfiniteScroll = () => {
		this.InfiniteScroll = new InfiniteScroll(this.postsContainer, {
			path: 'page/{{#}}',
			append: '.post',
			status: '.page-load-status',
			hideNav: '.pagination',
			button: this.loadMoreButton,
			scrollThreshold: false,
			history: false,
		});

		this.InfiniteScroll.on('append', (body, path, items) => {
			if (items.length < 6) {
				this.InfiniteScroll.destroy();
				this.loadMoreButton.style.display = 'none';
			}
		});
	};
}

export default Press;
